module.exports = __webpack_public_path__ + "static/media/400004_02.aaf97743.png";